<template>
    <!-- Rendered inside _LayoutPublic regardless of auth state - the /Docs/* pages are a
         self-contained docs mini-site with their own chrome, not a dashboard view. -->
    <div class="api-ref-shell q-pa-lg">
        <div class="row q-mb-md items-center">
            <div class="col">
                <h1 class="text-h4 q-my-none">API Reference
                    <span class="visually-hidden"> - eSign Launchpad REST API</span>
                </h1>
                <p class="text-subtitle1 text-grey-7 q-mt-sm q-mb-none">
                    Interactive documentation for the eSign Launchpad API
                </p>
            </div>
        </div>

        <q-card bordered v-if="error" class="q-mb-lg">
            <q-card-section class="text-center q-pa-xl">
                <q-icon name="error_outline" color="negative" size="48px" class="q-mb-md" />
                <div class="text-h6 q-mb-sm">Unable to load API specification</div>
                <div class="text-body2 text-grey-7 q-mb-md">{{ error }}</div>
                <q-btn color="primary" label="Retry" @click="checkSpec" />
            </q-card-section>
        </q-card>

        <div v-else-if="loading" class="text-center q-pa-xl">
            <q-spinner size="48px" color="primary" class="q-mb-md" />
            <div class="text-body1 text-grey-7">Loading API documentation...</div>
        </div>

        <iframe
            v-else
            src="/scalar/openapi"
            class="scalar-frame"
            frameborder="0"
            allowfullscreen
        ></iframe>
    </div>
</template>

<script>
export default {
    name: 'ApiReferencePage',

    data() {
        return {
            loading: true,
            error: null,
            specUrl: window._pageConfig?.openApiSpecUrl || '/docs/openapi.json'
        };
    },

    methods: {
        async checkSpec() {
            this.loading = true;
            this.error = null;

            try {
                const response = await fetch(this.specUrl);
                if (!response.ok) {
                    throw new Error(`API returned status ${response.status}`);
                }
                this.loading = false;
            } catch (err) {
                this.loading = false;
                this.error = err.message || 'Failed to load API specification';
            }
        }
    },

    mounted() {
        this.checkSpec();
    }
};
</script>

<style scoped>
.api-ref-shell {
    max-width: 1400px;
    margin: 0 auto;
}
.scalar-frame {
    width: 100%;
    height: calc(100vh - 160px);
    border: 1px solid #e0e0e0;
    border-radius: 8px;
}
</style>
